import type { iCustomerCreditVoucher } from "@sdk/customer-credit-vouchers/customer-credit-voucher-model";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectCustomerCreditVoucherQueryMap,
  selectEntityMap: selectCustomerCreditVouchersMap,
  selectQueryMapAll: selectCustomerCreditVouchersMapAll,
  selectQueryAllList: selectCustomerCreditVouchersAllList,
  selectAllEntities: selectAllCustomerCreditVouchers,
  selectAllEntitiesQuery: selectAllCustomerCreditVouchersQuery,
  selectEntityById: selectCustomerCreditVoucherById,
  selectEntityQuery: selectCustomerCreditVoucherQuery,
  selectEntityQueryList: selectCustomerCreditVoucherQueryList,
} = CreateSelectorForEntities<iStore, iCustomerCreditVoucher>({
  sliceName: "customerCreditVouchers",
});
